declare namespace $ {

	type $mol_string__hint_bog_smalljs_demo_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_smalljs_demo_2 = $mol_type_enforce<
		ReturnType< $bog_smalljs_demo['name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_paragraph__title_bog_smalljs_demo_3 = $mol_type_enforce<
		ReturnType< $bog_smalljs_demo['greeting'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $bog_smalljs_demo extends $mol_view {
		name( next?: string ): string
		Name( ): $mol_string
		greeting( ): string
		Greeting( ): $mol_paragraph
		guest( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=demo.view.tree.d.ts.map